import { Sprout, Calendar, Camera, HeartPulse, Droplets } from "lucide-react";
import { motion } from "framer-motion";

const TABS = [
  { id: "today", label: "Today", icon: Sprout, testid: "dashboard-tab" },
  { id: "water", label: "Water", icon: Droplets, testid: "water-tab" },
  { id: "journey", label: "Journey", icon: Calendar, testid: "journey-tab" },
  { id: "selfies", label: "Selfies", icon: Camera, testid: "selfie-tab" },
  { id: "health", label: "Health", icon: HeartPulse, testid: "health-tab" },
];

export default function BottomNav({ active, onChange }) {
  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md backdrop-blur-xl bg-white/85 border-t border-[#E9EFEA] px-2 pt-2 flex justify-between items-center z-40 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      {TABS.map((t) => {
        const Icon = t.icon;
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            data-testid={t.testid}
            onClick={() => onChange(t.id)}
            className="relative flex-1 flex flex-col items-center gap-0.5 py-1.5"
          >
            {isActive && (
              <motion.div
                layoutId="active-pill"
                className="absolute inset-x-1 inset-y-0 bg-[#E9F0E8] rounded-2xl -z-0"
              />
            )}
            <Icon
              className={`w-5 h-5 relative z-10 ${
                isActive ? "text-[#4A6B53]" : "text-[#6B7A70]"
              }`}
              strokeWidth={1.5}
            />
            <span
              className={`text-[10px] font-medium tracking-wide relative z-10 ${
                isActive ? "text-[#4A6B53]" : "text-[#6B7A70]"
              }`}
            >
              {t.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
